import React from "react";
import { Globe, Tv, Film, Video, Gamepad2, UploadCloud, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

const ICONS = {
  globe: Globe,
  tv: Tv,
  film: Film,
  video: Video,
  gamepad: Gamepad2,
  "upload-cloud": UploadCloud,
};

const LEVEL = {
  good: { color: "#34D399", bg: "rgba(52,211,153,0.08)", border: "rgba(52,211,153,0.35)", Icon: CheckCircle2, label: "Ready" },
  fair: { color: "#FBBF24", bg: "rgba(251,191,36,0.08)", border: "rgba(251,191,36,0.35)", Icon: AlertTriangle, label: "OK" },
  poor: { color: "#F87171", bg: "rgba(248,113,113,0.08)", border: "rgba(248,113,113,0.35)", Icon: XCircle, label: "Struggles" },
};

export function ActivityGrid({ activities, testid }) {
  if (!activities || !activities.length) return null;
  return (
    <div className="glass rounded-2xl p-5 sm:p-6" data-testid={testid || "activity-grid"}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display text-base sm:text-lg font-semibold">What your connection can do</h3>
        <span className="text-xs text-[var(--text-muted)] font-mono hidden sm:block">based on your results</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {activities.map((a) => {
          const Ic = ICONS[a.icon] || Globe;
          const L = LEVEL[a.level] || LEVEL.fair;
          return (
            <div
              key={a.id}
              data-testid={`activity-${a.id}`}
              className="rounded-xl p-4 border relative overflow-hidden lift"
              style={{ background: L.bg, borderColor: L.border }}
            >
              <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full pointer-events-none" style={{ background: `radial-gradient(closest-side, ${L.color}20, transparent)` }} />
              <div className="flex items-center justify-between mb-3 relative">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: `${L.color}18`, border: `1px solid ${L.color}40` }}>
                  <Ic className="w-4 h-4" style={{ color: L.color }} strokeWidth={2.2} />
                </div>
                <L.Icon className="w-4 h-4" style={{ color: L.color }} />
              </div>
              <div className="font-display text-sm font-semibold leading-tight mb-1">{a.name}</div>
              <div className="text-xs text-[var(--text-dim)]">{a.hint}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
